export default "__VITE_ASSET__ecd13679__"